<template>
  <v-layout row wrap align-center >
    <v-flex xs12 class="text-xs-left pb-4">
      <p>Start the certificate program by confirming your identity. This is the KEY to workplace compliance.</p>
    </v-flex>

    <v-flex xs12 >
      <v-text-field
        @keyup="changedEmail=true"
        @keyup.enter="confirmMyEmail"
        v-validate="'required|email'"
        autocomplete="new-password"
        :autofocus=true
        type="email"
        :error-messages="errors.collect('slot1.email')"
        data-vv-name="slot1.email"
        data-vv-scope="slot1"
        v-model="email"
        data-vv-validate-on="blur"
        label="E-mail address"
      ></v-text-field>
    </v-flex>

    <v-flex xs12 class="text-lg-left" v-if="!emailVerified">
      <v-btn
        block
        @click="confirmMyEmail"
        :disabled="!changedEmail || !email"
        :loading="loading" class="mr-0 ml-0"
        color="success">Get Started</v-btn>

      <v-btn
        v-if="otpGenerated"
        block
        @click="goToSignupStep(page, 'code-verification')"
        color="primary">Next &#8594;</v-btn>

    </v-flex>
    <v-flex style="display: flex;justify-content: end;width:100%;">
      <span style="text-decoration: underline;font-size: 12px">
            <Translate />
          </span>
    </v-flex>

    <v-flex xs12 class="text-lg-left" v-if="emailVerified">
      <v-btn
        block
        @click="confirmMyEmail"
        :disabled="!changedEmail"
        :loading="loading"
        class="mr-0 ml-0"
        color="success">Update</v-btn>
      <v-btn
        block
        @click="goToSignupStep(page, 'store-verification')"
        color="primary">Next &#8594;</v-btn>

    </v-flex>

    <v-flex align-center class="mt-5 grey--text">
      <p>
        Your personal data is kept secure, private and only used to operate your certificate program.
      </p>
      <p>
        We do not sell, give or show personal info to anyone else without your permission.
      </p>
    </v-flex>

    <v-dialog v-model="accountExistsDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline" v-text="'Account Exists'"/>
        <v-card-text>
          <p>Hello {{fName}},</p>
          <p>Your email id <span class="font-weight-bold" v-text="email"/> is already registered.</p>
          <p>To complete the registration process of <span class="font-weight-bold">{{appName}}</span>,
            please SIGN IN with the same email id and update your profile.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat to="/">Sign IN</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="switchAccountDialog" persistent :width="$store.getters.getAppWidth - 10">
      <v-card>
        <v-card-title class="headline" v-text="'Account Exists'"/>
        <v-card-text>
          <p>Hello {{fName}},</p>
          <p>Your email id <span class="font-weight-bold" v-text="email"/> is already registered.</p>
          <p>To complete the registration process of <span class="font-weight-bold">{{appName}}</span>,
            please SIGN IN with the same email id and update your profile.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat to="/">Sign IN</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="creationLoaderDialog"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please wait. Your account is being created...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-layout>
</template>

<script>
import crypto from '@/mixins/crypto'
import common from '@/mixins/common'
import { mapGetters, mapMutations } from 'vuex'
import Translate from '../../../Translate.vue'

export default {
  name: 'ConfirmMyEmail',
  components: {Translate},
  data () {
    return {
      creationLoaderDialog: false,
      switchAccountDialog: false,
      registerLoading: true,
      userFullName: '',
      loading: false,
      changedEmail: false,
      accountExistsDialog: false,
      apiUrl: process.env.API_URL,
      appName: process.env.APP_NAME,
      fName: '',
      lName: '',
      email: '',
      errorMsg: '',
      isLoader: false,
      dictionary: {
        custom: {
          'slot1.email': {
            required: () => 'Email is required',
            email: 'Please enter valid email id'
          }
        }
      }
    }
  },
  props: {
    page: {
      default: 'SignUp',
      type: String
    }
  },
  computed: {
    inputClassEmail () {
      return this.errorMsg !== '' ? 'validate invalid' : this.email !== '' ? 'validate valid' : ''
    },
    ...mapGetters('registration', ['getUserDetails']),

    emailVerified () {
      return this.getUserDetails.email_verified
    },
    otpGenerated () {
      return this.getUserDetails.email_otp_generated
    }
  },
  mounted () {
    this.$validator.localize('en', this.dictionary)
    this.email = this.decryptData(this.getUserDetails.email)
  },
  methods: {
    ...mapMutations('registration', [
      'setUser'
    ]),
    registerSfh () {
      // COPY OF 52 GetNameAndPwd
      const gameId = +process.env.GAME_ID

      this.creationLoaderDialog = true
      this.$store.commit('setLoadingDialog', true, { root: true })
      this.$http({
        url: process.env.API_URL + '/ws/userservice/course/' + gameId + '/register',
        method: 'POST',
        data: {
          'firstName': null,
          'lastName': null,
          'password': null,
          'email': this.email,
          'client': null,
          'otpId': null,
          'country': 233,
          'state': 1398,
          'app': null,
          'platform': null
        }
      }).then(() => {
        this.creationLoaderDialog = false
        this.$store.commit('setLoadingDialog', false, { root: true })
        this.$store.commit('flashSuccess', 'You are now registered with Safe Food Handler certificate program.')
        this.logout()
      }, error => {
        this.creationLoaderDialog = false
        this.$store.commit('setLoadingDialog', false, { root: true })
        this.$store.commit('flashError', error.message, { root: true })
        this.creationLoaderDialog = false
      }).catch(error => {
        this.creationLoaderDialog = false
        this.$store.commit('setLoadingDialog', false, { root: true })
        this.$store.commit('flashError', error.message, { root: true })
      })
    },
    logout () {
      this.$auth.logout({
        redirect: '/',
        makeRequest: false
      })
    },
    confirmMyEmail () {
      this.loading = true
      this.errors.clear('slot1')
      this.$store.dispatch('registration/sendOtp', this.email)
        .then((res) => {
          // console.log(res)
          if (res.userState && (res.userState === 2 || res.userState === 1)) {
            this.fName = res.firstName
            this.lName = res.lastName
            if (res.userState === 1) {
              this.switchAccountDialog = true
              this.loading = true
              this.userFullName = res.firstName + ' ' + res.lastName
              this.email = res.email
              // this.setUser({...this.getUserDetails, email_verified: true, first_name: res.firstName, last_name: res.lastName})
              // this.setUser({
              //   ...this.getUserDetails,
              //   email: this.encryptData(this.email),
              //   email_otp_generated: true,
              //   email_otp_id: null})
              // this.$router.push({name: 'SignUp', params: {step: 'get-name-and-pwd', email: this.$route.params.email}})
            } else {
              this.accountExistsDialog = true
            }
          } else {
            console.log('Response:', res)
            this.setUser({
              ...this.getUserDetails,
              email: this.encryptData(this.email),
              email_otp_generated: true,
              email_otp_id: res.data.otpId})

            this.$router.push({name: 'SignUp',
              params: {step: 'code-verification', otp_id: res.data.otpId}})
          }
          this.loading = false
        }, (err) => {
          this.loading = false
          this.errorMsg = 'Invalid email address.'
          this.errors.add({
            scope: 'slot1',
            field: 'email',
            msg: 'Invalid email address'
          })
          console.log('error found', err)
        }).catch((e) => {
          this.loading = false
          console.log('Caught', e)
        })
    }
  },
  mixins: [crypto, common]
}
</script>



// WEBPACK FOOTER //
// src/components/views/sign-up/69/ConfirmMyEmail.vue